import DropdownButton from "@/components/DropdownButton";
import SimpleTable from "@/components/SimpleTable";
import { handleCompanyUserName } from "@/lib/handleName";
import { CompanyUser } from "@/schema/CompanyUser";
import useMemberDialog from "@/src/console/(auth)/companies/[id]/_hooks/useMemberDialog";
import { useTranslation } from "react-i18next";

interface MemberTableProps {
  members: CompanyUser[];
}

function MemberTable({ members }: MemberTableProps) {
  const { t } = useTranslation();
  const { setDialog } = useMemberDialog();

  return (
    <SimpleTable
      data={members}
      columns={[
        {
          key: "name",
          label: t("name"),
          render: ({ id, name: temp, name_kana }) => {
            const name = handleCompanyUserName(id, temp);
            return name_kana ? name + " (" + name_kana + ")" : name;
          },
        },
        {
          key: "email",
          label: t("email"),
          render: ({ email, phone_number }) => (
            <div className=" flex flex-col space-y-[2px]">
              <span>{email}</span>
              <span>{phone_number}</span>
            </div>
          ),
        },
        {
          key: "role",
          label: t("role"),
          render: ({ role }) => (role === 0 ? t("admin") : t("member")),
        },
        {
          key: "position",
          label: t("position"),
          render: ({ position }) => (position ? position : "--"),
        },
        {
          key: "department",
          label: t("department"),
          render: ({ department }) => (department ? department : "--"),
        },
        {
          width: "200px",
          key: "action",
          label: t("action"),
          render: (member) => {
            return (
              <DropdownButton
                items={[
                  {
                    item: t("edit"),
                    key: "edit",
                    onClick: () => setDialog({ type: "edit", member: member }),
                  },
                  {
                    item: t("change-password"),
                    key: "change-password",
                    onClick: () =>
                      setDialog({ type: "reset-password", member: member }),
                  },
                  {
                    item: <span className="text-red-500">{t("delete")}</span>,
                    key: "delete",
                    onClick: () => setDialog({ type: "delete", member }),
                  },
                ]}
              />
            );
          },
        },
      ]}
    />
  );
}

export default MemberTable;
